import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';

import {
  deleteTanquesVirtual,
  findTanquesVirtual,
  recordFiltering,
} from '~/store/modules/tanquevirtual/actions';

import Form from './form';

export default function CadastroTanqueVirtual() {
  const data = useSelector((state) => state.tanquevirtual);

  const listaStatusPesquisa = useMemo(
    () => [
      { label: 'liberado', value: 'liberado' },
      { label: 'bloqueado', value: 'bloqueado' },
      { label: 'cancelado', value: 'cancelado' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'tavi_codigo',
        label: 'Código',
        filter: { type: 'text' },
        align: 'center',
      },
      { id: 'tavi_nome', label: 'Descrição', filter: { type: 'text' } },
      { id: 'poco_descricao', label: 'Posto', filter: { type: 'text' } },
      { id: 'prod_descricao', label: 'Produto', filter: { type: 'text' } },
      {
        id: 'tavi_status_string',
        label: 'Status',
        align: 'center',
        filter: {
          type: 'select',
          options: listaStatusPesquisa,
        },
      },
    ],
    []
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="tavi_codigo ASC"
      read={recordFiltering}
      remove={deleteTanquesVirtual}
      form={Form}
      find={findTanquesVirtual}
      redux={data}
      header={header}
      detach="tavi_nome"
      keys={['tavi_codigo', 'poco_codigo']}
      view="VW_TB_TANQUEVIRTUAL"
      reportTitle="Cadastro de Tanque Virtual"
    />
  );
}
